<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-title>
      <v-row
        class="mb-12"
        no-gutters
      >
      <v-col
        cols="12"
      >
        <v-alert
          color="error"
        >
          <div class="white--text">
            Stampando i bollettini verrà intaccata la giacenza
          </div>
          <div class="white--text font-weight-bold">Attenzione i bollettini verrano stampati 50 per volta!</div>
        </v-alert>
      </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >
      <ValidationProvider
            rules="required"
            vid="propagandist"
            :name="$t('fields.propagandist').toLowerCase()"
            v-slot="{ errors }"
        >
          <PropagandistSelect
            :errors="errors"
            v-model="form.propagandist_id"
          >
          </PropagandistSelect>
        </ValidationProvider>


          <ValidationProvider
                rules="required"
                vid="shipping_type"
                :name="$t('fields.type_shipping').toLowerCase()"
                v-slot="{ errors }"
            >
            <v-select
                v-model="form.shipping_type"
                :items="[
                  { value: 'ALL', label: 'Tutti' },
                  { value: 'SCHOOL', label: 'Scuola' },
                  { value: 'OTHER', label: 'Casa' }
                ]"
                item-text="label"
                item-value="value"
                :label="$t('fields.type_shipping')"
            >
            </v-select>
          </ValidationProvider>

          <ValidationProvider
                rules="required"
                vid="name"
                :name="$t('fields.note').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-text-field
                v-model=" form.name"
                :counter="255"
                :label="$t('fields.note')"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>

          <v-row
            v-if="isShippingTypeSchool"
          >
            <v-col
              cols="4"
            >
              <v-checkbox
                :label="$t('fields.enable_search_school')"
                v-model="enableSchoolSearch"
                :value="true"
              >
              </v-checkbox>
            </v-col>
            <v-col
              cols="4"
            >
              <v-checkbox
              :label="$t('fields.enable_search_teacher')"
                v-model="enableTeacherSearch"
                :value="true"
                :disabled="!enableSchoolSearch"
              >
              </v-checkbox>
            </v-col>
          </v-row>
            <SchoolSelection
              v-if="form.propagandist_id && enableSchoolSearch && isShippingTypeSchool"
              v-model="form.schoolIds"
              :propagandistId="form.propagandist_id"
              :key="form.propagandist_id"
            >
            </SchoolSelection>

            <SchoolTeacherSelection
              v-model="form.teacherIds"
              v-if="form.schoolIds.length && enableTeacherSearch && isShippingTypeSchool"
              :school-ids="getSchoolIdsSelected"
              :key="form.schoolIds.length"
            >

            </SchoolTeacherSelection>
    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn :disabled="isNotReadyToSave" @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import PropagandistSelect from '../../shared/Vselects/PropagandistSelect.vue';
  import SchoolSelection from '../../app/Schools/SchoolSelection.vue';
  import SchoolTeacherSelection from '../../app/Schools/SchoolTeacherSelection.vue';

  export default {
    name: 'BullettinModal',
    components: {
      PropagandistSelect,
      SchoolSelection,
      SchoolTeacherSelection,
    },
    data() {
      return {

        stored: null,
        enableSchoolSearch: false,
        enableTeacherSearch: false,
        form: {
         name: '',
         shipping_type: 'ALL',
         propagandist_id: null,
         schoolIds: [],
         teacherIds: [],
        },
        loading: false,
        errors: {},
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      getSchoolIdsSelected() {
        return this.form.schoolIds.map(x => x.school_id);
      },

      geTeacherIdsSelected() {
        return this.form.teacherIds.map(x => x.id);
      },

      isSchoolNotSelected() {
        return Boolean(!this.form.schoolIds.length && this.enableSchoolSearch && this.isShippingTypeSchool);
      },

      isTeacherNotSelected() {
        return Boolean(!this.form.teacherIds.length && this.enableTeacherSearch && this.isShippingTypeSchool);
      },

      isNotReadyToSave() {
        if (this.isSchoolNotSelected) {
          return true;
        }

        if (this.isTeacherNotSelected) {
          return true;
        }


        return false;
      },

      isShippingTypeSchool() {
        return this.form.shipping_type === 'SCHOOL';
      },

    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),
      async save() {
        const isValid = await this.$refs.form.validate();

        if (isValid) {
            if (this.options.onSave) {
              this.loadingModal(true);

              const { form } = this;
              if (this.isShippingTypeSchool) {
                form.schoolIds = this.form.schoolIds.map(x => x.school_id);
                form.teacherIds = this.form.teacherIds.map(x => x.id);
              }


              this.options.onSave(
                form,
                this.$refs.form,
              )
              .then(() => {
                  this.loadingModal(false);
              }).then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  this.handleError(error, this.errors);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },
    async created() {
      // this.loadingModal(true);
      // this.loadingModal(false);
    },

    watch: {},

  };
</script>
